export function useTalkdeskLoader() {
  const { load } = useScript(
    {
      src: 'https://talkdeskchatsdk.talkdeskapp.com/v2/talkdeskchatsdk.js',
      crossorigin: 'anonymous',
    },
    {
      trigger: 'manual',
    },
  )

  return load()
}
